<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <label class="form-label">Type</label> 
                <div class="d-flex">
                    <div class="form-check me-5">
                        <input class="form-check-input" id="type_organisation" type="radio" name="type" [(ngModel)]="item['type']" [value]="'organisation'"> 
                        <label class="form-check-label" for="type_organisation">Organisatie</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" id="type_individual" type="radio" name="type" [(ngModel)]="item['type']" [value]="'individual'"> 
                        <label class="form-check-label" for="type_individual">Individu</label>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12">
                <label class="form-label">Naam</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['name']}"
                    type="text" 
                    [(ngModel)]="item['name']" 
                    class="form-control" 
                    placeholder="Bijv. Erik de Vries of Uitgeverij NEO">
            </div>
        </div>
        <div class="row mb-3" *ngIf="item['type'] === 'individual'">
            <div class="col-4">
                <label class="form-label">Voornaam</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['givenName']}"
                    type="text" 
                    [(ngModel)]="item['givenName']" 
                    class="form-control" 
                    placeholder="Erik">
            </div>
            <div class="col-4">
                <label class="form-label">Tussenvoegsel</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['familyNamePrefix']}"
                    type="text" 
                    [(ngModel)]="item['familyNamePrefix']" 
                    class="form-control" 
                    placeholder="de">
            </div>
            <div class="col-4">
                <label class="form-label">Achternaam</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['familyName']}"
                    type="text" 
                    [(ngModel)]="item['familyName']" 
                    class="form-control" 
                    placeholder="Vries">
            </div>
        </div>

        <div class="form-buttons">
		    <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="item['id']">Toevoegen</span>
                <span *ngIf="!item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>